export class AppModule {
  ModuleId: number;
  ModuleName: string;
}

export interface IAppModule {
  ModuleId: number;
  ModuleName: string;
}
